'use strict';

var angular = require('angular');

require('angular-route');
require('angular-moment');
require('angular-ui-bootstrap');
require('satellizer');
require('ng-sortable');

var app = angular.module('attendance', ['ngRoute', 'ui.bootstrap', 'angularMoment', 'satellizer', 'as.sortable']);

// Alert exceptions
app.config(['$provide', function($provide) {
	$provide.decorator('$exceptionHandler', ['$delegate', function($delegate) {
		return function(exception, cause) {
			alert(exception.message || cause || JSON.stringify(exception));
			$delegate(exception, cause);
		};
	}]);
}]);

var getAbsoluteUrl = (function() {
	var a;

	return function(url) {
		if(!a) a = document.createElement('a');
		a.href = url;

		return a.href;
	};
})();

app.config(['$authProvider', function($authProvider) {
	$authProvider.google({
		url: getAbsoluteUrl('auth/google'),
		redirectUri: getAbsoluteUrl('wait'),
		clientId: jsonPreload['google_client_id'],
		responseType: 'code'
	});

	$authProvider.twitter({
		url: getAbsoluteUrl('auth/twitter'),
		redirectUri: getAbsoluteUrl('wait'),
		responseType: 'code'
	});
}]);

app.config(['$httpProvider', function($httpProvider) {
	$httpProvider.interceptors.push(['$q', '$location', '$rootScope', '$injector', function ($q, $location, $rootScope, $injector) {
	   return {
	       'request': function (config) {
	           config.headers = config.headers || {};
	           if ($rootScope.token) {
	               config.headers.Authorization = 'Bearer ' + $rootScope.token;
	           }
	           return config;
	       },
	       'responseError': function (response) {
	           if (response.status === 401 || response.status === 403) {
	               // Late-load $auth and log out
	               $injector.get('$auth').logout();
	               // Reload the page
	               window.location = getAbsoluteUrl("login");
	           }
	           return $q.reject(response);
	       }
	   };
	}]);
}]);

app.filter('toArray', function () {
  return function (obj, addKey) {
    if ( addKey === false ) {
      return Object.keys(obj).map(function(key) {
        return obj[key];
      });
    } else {
      return Object.keys(obj).map(function (key) {
        if(typeof obj[key] == 'object') return Object.defineProperty(obj[key], '$key', { enumerable: false, value: key});
      });
    }
  };
});

require('./controller');
